const map = {
  "Plugilo.Analytics.ClickOuts": "Click outs",
  "Plugilo.Analytics.ClicksToTheContent": "Clicks",
  "Plugilo.Analytics.Clicks": "Clicks",
};

export default map;
